const mutations = {
  
    ADD_CURSO (state, value) {

        state.tipoCurso.push(value)

    },
    GET_TIPO_CURSO (state, value) {

        state.tipoCurso = value

    },
}

export default mutations